import React, { useEffect, useState } from "react";
import axios from "axios";
import routes from "../../routes/routes";

import BlogData from "./blogdata";
import BlogList from "./bloglist";

const BlogEvent = () => {
  const [events, setEvents] = useState([]);

  useEffect(() => {
    axios
      .get(routes.api.getEvent)
      .then((res) => {
        // Add null checks and ensure we have valid data
        if (
          res.data &&
          res.data[0] &&
          res.data[0].data &&
          Array.isArray(res.data[0].data)
        ) {
          setEvents(res.data[0].data);
        } else {
          console.warn("Invalid API response structure:", res.data);
          setEvents([]);
        }
        // console.log(res.data[0].data);
      })
      .catch((err) => {
        console.log(err);
        setEvents([]); // Set empty array on error
      });
  }, []);

  return (
    <>
      {Array.isArray(events) && events.length > 0 ? (
        events.map((item, index) => <BlogList key={index} {...item} />)
      ) : (
        <div>No events available</div>
      )}
    </>
  );
};

export default BlogEvent;
